import React from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import {DashboardCard} from "./dashboardCard";
import {useDashboardTableData} from "./useDashboardTableData";

export const DashboardTable = () => {
  const {organizations} = useDashboardTableData();
  return (
    <div className="table-container">
      <ListView
        listItems={organizations}
        listHeaders={["name", "total_system", "is_active", "created"]}
        cardContent={DashboardCard}
      />
    </div>
  );
};
